"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROARR_LOG_FORMAT_VERSION = exports.ROARR_VERSION = void 0;
// This needs to be updated manually because there is no way
// to know the package version at the build time.
exports.ROARR_VERSION = '5.0.0';
exports.ROARR_LOG_FORMAT_VERSION = '2.0.0';
//# sourceMappingURL=config.js.map